import { lazy, Route } from '@tanstack/router'

import { profileRoute } from '.'

const RedeemBonus = lazy(() => import('../../pages/profile/redeem-bonus'))

export const redeemBonusRoute = new Route({
  getParentRoute: () => profileRoute,
  path: 'redeem-bonus',
  component: RedeemBonus,
})
